export default __webpack_public_path__ + "static/media/flashSaleIcon.397ca78b.svg";